/** 文件说明
@Author: dalang
@LastModifyTime: 2022-05-08  17:41:46
@Desc: 个人中心-万知商务模块路由表(用户)
**/
// const BusinessRequireInfo = () => import('@/components/business/pages/BusinessInformation/Index')
const PersonCenterMall = () => import('@/components/user/business')
const Order = () => import('@/components/user/business/Order')
const OrderDetail = () => import('@/components/user/business/OrderDetail')
const OrderEvaluation = () => import('@/components/user/business/OrderEvaluation')
const Evaluation = () => import('@/components/user/business/Evaluation')
const ConfigAddress = () => import('@/components/user/business/shouhuoAddress/ConfigAddress')
const EditShouHuoAddress = () => import('@/components/user/business/shouhuoAddress/AddShouHuoAddress')
const FoucesGoods = () => import('@/components/user/business/focusGoods')
const Message = () => import('@/components/user/business/message')
const Need = () => import('@/components/user/business/need')
const ReturnOrder = () => import('@/components/user/business/returnGoods')

export default {
  path: '/user/wzmall',
  name: 'UserMall',
  component: PersonCenterMall,
  meta: {
    title: '万知商务-用户中心'
  },
  children: [
    {
      path: '/usercenter/wzmall/order',
      name: 'Order',
      component: Order,
      meta: {
        title: '个人中心-订单列表'
      }
    },
    {
      path: '/usercenter/wzmall/orderDetail',
      name: 'OrderDetail',
      component: OrderDetail,
      meta: {
        title: '个人中心-订单详情'
      }
    },
    {
      path: '/usercenter/wzmall/orderEvaluation',
      name: 'OrderEvaluation',
      component: OrderEvaluation,
      meta: {
        title: '个人中心-晒单评价'
      }
    },
    {
      path: '/usercenter/wzmall/publicEvaluation',
      name: 'Evaluation',
      component: Evaluation,
      meta: {
        title: '个人中心-发布评论'
      }
    },
    {
      path: '/usercenter/wzmall/configAddress',
      name: 'ConfigAddress',
      component: ConfigAddress,
      meta: {
        title: '个人中心-管理收货地址'
      }
    },
    {
      path: '/usercenter/wzmall/editAddress',
      name: 'EditShouHuoAddress',
      component: EditShouHuoAddress,
      meta: {
        title: '个人中心-新增/编辑收货地址'
      }
    },
    {
      path: '/usercenter/wzmall/focusGoods',
      name: 'FocusGoods',
      component: FoucesGoods,
      meta: {
        title: '个人中心-我的收藏'
      }
    },
    {
      path: '/usercenter/wzmall/message',
      name: 'Message',
      component: Message,
      meta: {
        title: '个人中心-我的留言'
      }
    },
    {
      path: '/usercenter/wzmall/need',
      name: 'Need',
      component: Need,
      meta: {
        title: '个人中心-需求查看'
      }
    },
    {
      path: '/usercenter/wzmall/returnOrder',
      name: 'ReturnOrder',
      component: ReturnOrder,
      meta: {
        title: '个人中心-退货订单'
      }
    }
  ]
}



// WEBPACK FOOTER //
// ./src/router/businessPersonCenter.js